import { POST } from './API';

const PATH_ROOT = 'U001';

export type A01Input = {
  phoneNumber: string;
  lang: string;
  recaptcha_token: string;
};
export type A01Output = {
  status: string;
  msgid: string;
};
export async function A01(input: A01Input, cancellation?: AbortSignal): Promise<A01Output> {
  return await POST(`${PATH_ROOT}/user_id_confirmation`, {
    phone_number: input.phoneNumber,
    lang: input.lang,
    recaptcha_token: input.recaptcha_token,
    signal: cancellation,
  });
}

export type A02Output = {
  status: string;
  msgid: string;
};
export async function A02(cancellation?: AbortSignal): Promise<A02Output> {
  return await POST(`${PATH_ROOT}/update_last_login`, {
    signal: cancellation,
  });
}
